// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fg-0";
export var headerCellHover = "_fg-1";
export var readCellContainer = "_fg-2";
export var unreadIndicator = "_fg-3";